.root {
  overflow: hidden;
}

.content {
  padding: var(--spacing-xs) var(--spacing-xs) var(--spacing-m) var(--spacing-xs);
}
